<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="description" content="Automated AI translations of Vahid Online reporting. Exported from the Telegram Channel. Original content also available on X/Twitter.">
    <title>${$global.meta.pageTitle || "Vahid Online in English"}</title>
    <!-- Privacy-friendly analytics by Plausible -->
    <html-script async src="https://plausible.io/js/pa-AuexjMRcR5dkrORMnMss6.js"></html-script>
    <script>
      window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};
      plausible.init();
    </script>
  </head>
  <body>
    <${input.content}/>
  </body>
</html>

<style>
  @import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&family=IBM+Plex+Sans:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600&display=swap");

  :global(*) {
    box-sizing: border-box;
  }

  :global(:root) {
    --bg: #f4f1ea;
    --paper: #fffdf8;
    --ink: #181612;
    --muted: #6b6358;
    --rule: #d8d0c3;
    --accent: #253c6a;
    --accent-soft: #dfe8fb;
    --warning: #7a2c2c;
  }

  html,
  body {
    margin: 0;
    min-height: 100%;
    color: var(--ink);
    background: var(--bg);
    font-family: "IBM Plex Sans", "Segoe UI", sans-serif;
  }

  a {
    color: var(--accent);
  }

  a:hover {
    color: #1d3159;
  }
</style>

<script>
  /* ---- Media gallery lightbox ---- */
  (function () {
    /* --- Inject gallery CSS (framework style blocks don't reach JS-created DOM) --- */
    var css = [
      ".gl-overlay{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .15s ease;pointer-events:none}",
      ".gl-overlay.gl-open{opacity:1;pointer-events:auto}",
      ".gl-overlay[hidden]{display:none}",
      ".gl-backdrop{position:absolute;inset:0;background:rgba(24,22,18,.94)}",
      ".gl-wrap{position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:2.5rem 3.5rem}",
      ".gl-close{position:absolute;top:.6rem;right:.6rem;z-index:2;border:0;background:0 0;color:rgba(255,255,255,.6);font:2rem/1 'IBM Plex Sans',sans-serif;cursor:pointer;padding:.3rem .55rem;transition:color .15s}",
      ".gl-close:hover{color:#fff}",
      ".gl-nav{position:absolute;top:50%;transform:translateY(-50%);z-index:2;border:0;background:rgba(255,255,255,.07);color:rgba(255,255,255,.7);font:2rem/1 'IBM Plex Sans',sans-serif;cursor:pointer;padding:.65rem .7rem;border-radius:4px;transition:background .15s,color .15s}",
      ".gl-nav:hover:not(:disabled){background:rgba(255,255,255,.14);color:#fff}",
      ".gl-nav:disabled{opacity:.2;cursor:default}",
      ".gl-prev{left:.6rem}",
      ".gl-next{right:.6rem}",
      ".gl-body{display:flex;align-items:center;justify-content:center;z-index:1;max-width:100%;max-height:100%}",
      ".gl-body img,.gl-body video{display:block;max-width:calc(100vw - 7rem);max-height:calc(100vh - 5rem);width:auto;height:auto;object-fit:contain;border-radius:2px;background:#000}",
      ".gl-body img{background:transparent}",
      ".gl-count{position:absolute;bottom:.65rem;left:50%;transform:translateX(-50%);z-index:2;color:rgba(255,255,255,.5);font:.72rem/1.2 'IBM Plex Mono',monospace;letter-spacing:.06em}",
      ".gl-count[hidden]{display:none}",
      "@media(max-width:640px){",
      "  .gl-wrap{padding:2rem .4rem}",
      "  .gl-body img,.gl-body video{max-width:calc(100vw - .8rem);max-height:calc(100vh - 4rem)}",
      "  .gl-nav{font-size:1.5rem;padding:.45rem .5rem}",
      "  .gl-prev{left:.2rem}.gl-next{right:.2rem}",
      "}",
      "@media(prefers-reduced-motion:reduce){.gl-overlay{transition:none}}",
      /* inline thumb styles for the gallery trigger buttons */
      ".gl-thumb{border:0;background:0 0;padding:0;margin:0;cursor:pointer;position:relative;display:inline-block;line-height:0}",
      ".gl-thumb:focus-visible{outline:2px solid #253c6a;outline-offset:2px}",
      ".gl-thumb video,.gl-thumb img{pointer-events:none}",
      ".gl-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;transition:background .15s}",
      ".gl-play::after{content:'';width:3.2rem;height:3.2rem;border-radius:50%;background:rgba(0,0,0,.45);box-shadow:0 0 0 3px rgba(255,255,255,.25);display:flex;align-items:center;justify-content:center;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpolygon points='9.5,7 16.5,12 9.5,17'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:center;background-size:1.4rem}",
      ".gl-thumb:hover .gl-play::after{background-color:rgba(0,0,0,.6);box-shadow:0 0 0 3px rgba(255,255,255,.4)}",
    ].join("\n");

    var styleEl = document.createElement("style");
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    /* --- Gallery state --- */
    var overlay = null;
    var bodyEl = null;
    var countEl = null;
    var prevBtn = null;
    var nextBtn = null;
    var items = [];
    var idx = 0;

    function build() {
      overlay = document.createElement("div");
      overlay.className = "gl-overlay";
      overlay.hidden = true;
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", "Media gallery");
      overlay.tabIndex = -1;

      var backdrop = document.createElement("div");
      backdrop.className = "gl-backdrop";

      var wrap = document.createElement("div");
      wrap.className = "gl-wrap";

      var close = document.createElement("button");
      close.type = "button";
      close.className = "gl-close";
      close.setAttribute("aria-label", "Close gallery");
      close.innerHTML = "\u00d7";

      prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "gl-nav gl-prev";
      prevBtn.setAttribute("aria-label", "Previous");
      prevBtn.innerHTML = "\u2039";

      bodyEl = document.createElement("div");
      bodyEl.className = "gl-body";

      nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "gl-nav gl-next";
      nextBtn.setAttribute("aria-label", "Next");
      nextBtn.innerHTML = "\u203a";

      countEl = document.createElement("div");
      countEl.className = "gl-count";

      wrap.append(close, prevBtn, bodyEl, nextBtn, countEl);
      overlay.append(backdrop, wrap);
      document.body.appendChild(overlay);

      backdrop.addEventListener("click", shut);
      close.addEventListener("click", shut);
      prevBtn.addEventListener("click", function () { go(-1); });
      nextBtn.addEventListener("click", function () { go(1); });
      bodyEl.addEventListener("click", function (e) { e.stopPropagation(); });
    }

    function open(list, start) {
      items = list;
      idx = start;
      if (!overlay) build();
      overlay.hidden = false;
      /* trigger reflow so the opacity transition plays */
      void overlay.offsetWidth;
      overlay.classList.add("gl-open");
      document.body.style.overflow = "hidden";
      show();
      overlay.focus();
    }

    function shut() {
      if (!overlay) return;
      var vid = bodyEl.querySelector("video");
      if (vid) vid.pause();
      bodyEl.innerHTML = "";
      overlay.classList.remove("gl-open");
      overlay.hidden = true;
      document.body.style.overflow = "";
      items = [];
      idx = 0;
    }

    function show() {
      var vid = bodyEl.querySelector("video");
      if (vid) vid.pause();
      bodyEl.innerHTML = "";

      var item = items[idx];
      if (!item) return;

      if (item.type === "video") {
        var v = document.createElement("video");
        v.src = item.src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        bodyEl.appendChild(v);
      } else {
        var img = document.createElement("img");
        img.src = item.src;
        img.alt = "";
        bodyEl.appendChild(img);
      }

      var multi = items.length > 1;
      countEl.textContent = multi ? (idx + 1) + " \u2044 " + items.length : "";
      countEl.hidden = !multi;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx === items.length - 1;
    }

    function go(dir) {
      var n = idx + dir;
      if (n < 0 || n >= items.length) return;
      idx = n;
      show();
    }

    /* --- Open on click --- */
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-gl-item]");
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      var container = trigger.closest("[data-gl]");
      if (!container) return;

      var all = Array.from(container.querySelectorAll("[data-gl-item]"));
      var list = all.map(function (el) {
        return { src: el.dataset.glSrc, type: el.dataset.glType || "image" };
      });
      open(list, Math.max(0, all.indexOf(trigger)));
    });

    /* --- Keyboard --- */
    document.addEventListener("keydown", function (e) {
      if (!overlay || overlay.hidden) return;
      if (e.key === "Escape") { shut(); e.preventDefault(); }
      else if (e.key === "ArrowLeft") { go(-1); e.preventDefault(); }
      else if (e.key === "ArrowRight") { go(1); e.preventDefault(); }
    });
  })();
</script>
